<div class="align-items-center d-flex has-border mt-3 ordersummary-header pb-2">
  <div class="col align-items-center d-flex">
    <h2 class="m-0 wordwrap sec-title">
      {{ taskType === 1 ? "Sales Task" : "Production Task" }}
    </h2>
    <div class="lds-ring inline ms-2" *ngIf="salesTaskSmallLoader">
      <jni-spinner></jni-spinner>
    </div>
    <div class="ms-3 nav-link p-0" *ngIf="taskType === 1">
      <a class="link" (click)="addSalesTaskRowPreview()"
        ><i class="pi pi-plus"></i> Add New</a
      >
    </div>
    <div
      class="ordersummary-panel ml-auto d-flex justify-content-between"></div>
  </div>
  <div class="col-auto d-flex align-items-center justify-content-between gap-3">
    <div class="collapse-section border-0">
      <a
        class="btn-collapse"
        (click)="onTaskToggle()"
        [ngClass]="{ active: collapseSalesTaskStatus }"
        >{{ collapseSalesTaskHeading }} <i class="pi pi-angle-double-down"></i
      ></a>
    </div>
  </div>
</div>

<div class="cstm-collaspse mb-2 mt-2 pro-task01">
  <div class="row collapseable zeroHeight" [hidden]="collapseSalesTaskStatus">
    <div class="orders-list">
      <p-table
        stripedRows
        [rowHover]="true"
        [rows]="25"
        [showCurrentPageReport]="true"
        [scrollable]="true"
        scrollHeight="calc(100vh - 310px)"
        [size]="'small'"
        [resizableColumns]="true"
        #dtTaskList
        responsiveLayout="scroll"
        [value]="taskList"
        styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg scroll-tble"
        [rowHover]="true"
        [rows]="20"
        [paginator]="false"
        [filterDelay]="0"
        selectionMode="single"
        editMode="row"
        dataKey="taskId"
        [showCurrentPageReport]="true"
        styleClass="table-listing">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <th *ngIf="showEdit"></th>
            <th class="" *ngIf="taskType === 1">Client</th>
            <th class="" *ngIf="taskType === 1">Job Name</th>
            <th class="" *ngIf="taskType === 1">Project Number</th>
            <th class="" *ngIf="taskType === 2">PO #</th>
            <th class="" *ngIf="taskType === 2">Supplier</th>
            <th class="">Nickname</th>
            <th class="" *ngIf="taskType === 2">ESD</th>
            <th class="">IHD</th>
            <th class="">Task</th>
            <th class="">Due Date</th>
            <th class="">Priority</th>
            <th class="">Assigned To</th>
            <th class="">Created By</th>
            <th class="">Owner</th>
            <th class="">Note</th>
            <th class="" *ngIf="taskType === 1">Status</th>
            <th class="" *ngIf="taskType === 2">Status</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-task
          let-rowIndex="rowIndex"
          let-editing="editing">
          <ng-container>
            <tr [formGroup]="taskForm" *ngIf="isAdd && rowIndex === 0">
              <td>
                <!-- <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-save"
                  (click)="addTask()"
                  class="p-button-rounded p-button-text p-button-info p-mr-2 selectable-color selectable-color"></button>
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-danger"
                  (click)="refreshGrid()"></button> -->

                <p-button
                  icon="pi pi-save"
                  [rounded]="true"
                  [text]="true"
                  (click)="addTask()" />

                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  (click)="refreshGrid()" />
              </td>
              <td class="" *ngIf="taskType === 1">
                {{ task.client || "" }}
              </td>
              <td class="number text-truncate max-width-10 text-center" *ngIf="taskType === 1" pTooltip="{{ task.jobName}}" tooltipPosition="right" placeholder="Right">
                {{ task.jobName || "" }}
              </td>
              <td class="" *ngIf="taskType === 1">
                {{ task.projectWorkflowId || "" }}
              </td>
              <!-- <td class="" *ngIf="taskType === 2">
                                {{ task.proposalIDD365 || '' }}
                            </td>
                            <td class="number text-center" *ngIf="taskType === 2"  formGroupName="subTask">
                                {{ task.supplierName }}
                            </td>
                            <td class="" *ngIf="taskType === 2" formGroupName="subTask">
                                {{ task.nickName }}
                            </td> -->

              <td
                [ngClass]="getLineIHDClass(task)"
                class=""
                formGroupName="subTask">
                <!-- {{ task.ihd | date: 'MM-dd-yyyy' || '' }} -->
                <!-- <div class="form-group has-float-label mb-3 mt-4">
                                    <input pInputText  jniAutoCompleteBlocker type="text" formControlName="ihd" class="form-control" 
                                    [ngClass]="{
                                        'error-state': isFieldInvalid('subTask', 'ihd')
                                    }"/>
                                </div>  -->
                <div class="form-group has-float-label mb-3 mt-4">
                  <p-datePicker
                    [selectOtherMonths]="true"
                    appendTo="body"
                    jniAutoCompleteBlocker
                    [style]="{ width: '100%' }"
                    [showButtonBar]="false"
                    [minDate]="currentdate"
                    [defaultDate]="currentdate"
                    formControlName="ihd"
                    [ngClass]="{
                      'error-state': isFieldInvalid('subTask', 'ihd'),
                    }">
                  </p-datePicker>
                </div>
              </td>
              <td class="" formGroupName="parentTask">
                <div class="form-group has-float-label mb-3 mt-4">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    formControlName="title"
                    class="form-control"
                    [ngClass]="{
                      'error-state': isFieldInvalid('parentTask', 'title'),
                    }" />
                </div>
              </td>
              <td class="" formGroupName="subTask">
                <div class="form-group has-float-label mb-3 mt-4">
                  <p-datePicker
                    [selectOtherMonths]="true"
                    appendTo="body"
                    jniAutoCompleteBlocker
                    [style]="{ width: '100%' }"
                    [showButtonBar]="false"
                    [minDate]="currentdate"
                    [defaultDate]="currentdate"
                    formControlName="dueDate"
                    [ngClass]="{
                      'error-state': isFieldInvalid('subTask', 'dueDate'),
                    }">
                  </p-datePicker>
                </div>
              </td>
              <td class="" formGroupName="subTask">
                <p-select
                  formControlName="priority"
                  notFoundText="No List Found"
                  appendTo="body"
                  [options]="priorityLevelFiltered"
                  optionLabel="title"
                  optionValue="id"
                  [filter]="true"
                  [showClear]="true">
                </p-select>
              </td>
              <td class="" formGroupName="subTask">
                <p-select
                  formControlName="assignedTo"
                  notFoundText="No List Found"
                  appendTo="body"
                  [filter]="true"
                  [showClear]="true"
                  [(ngModel)]="task.assignedTo"
                  (onChange)="onSingleFieldEdit(task, 'assignedTo', $event)"
                  [options]="renderUsers(ownerList)"
                  optionLabel="name"
                  optionValue="name">
                </p-select>
              </td>
              <td class=""></td>
              <td class=""></td>
              <td class="text-center number"></td>
              <td class="" formGroupName="subTask" *ngIf="taskType === 1">
                <p-select
                  notFoundText="No List Found"
                  formControlName="taskStatus"
                  appendTo="body"
                  [filter]="true"
                  [showClear]="true"
                  [options]="statusList"
                  optionLabel="name"
                  (onChange)="updateTaskStatus($event.value, task.taskId)"
                  optionValue="value">
                </p-select>
              </td>
              <!-- <td class="" formGroupName="subTask" *ngIf="taskType === 2">
                                <ng-select
                                    class="p-0"
                                    notFoundText="No List Found"
                                    formControlName="taskStatus"
                                    appendTo="body">
                                    <ng-option *ngFor="let item of productionStatusList" [value]="item.id" >
                                        <span >{{ item.status }}</span>
                                    </ng-option>
                                </ng-select>
                            </td> -->
            </tr>

            <tr
              *ngIf="!defaultTask"
              [formGroup]="taskForm"
              class="p-selectable-row"
              [pSelectableRow]="task"
              [pEditableRow]="task">
              <td>
                <button
                  [disabled]="isDisableLink"
                  *ngIf="!editing"
                  pButton
                  pRipple
                  type="button"
                  pInitEditableRow
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text"
                  (click)="editLine(task.taskId)"></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pSaveEditableRow
                  icon="pi pi-check"
                  (click)="onRowEditSave(task)"
                  class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color selectable-color"></button>
                <button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pCancelEditableRow
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-danger"
                  (click)="refreshGrid()"></button>
              </td>
              <td class="name" *ngIf="taskType === 1">
                {{ task.client }}
              </td>
              <td class="number text-truncate max-width-10" *ngIf="taskType === 1" pTooltip="{{ task.jobName}}" tooltipPosition="top" placeholder="top">
                {{ task.jobName }}
              </td>
              <td class="name" *ngIf="taskType === 1">
                {{ task.projectWorkflowId }}
              </td>
              <td class="" *ngIf="taskType === 2">
                {{ task.poNumber }}
              </td>
              <td class="number" *ngIf="taskType === 2">
                {{ task.supplierName }}
              </td>
              <td class="name text-truncate max-width-10" formGroupName="subTask" pTooltip="{{ task.nickName }}" tooltipPosition="top" placeholder="top">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <div class="form-group has-float-label mb-3 mt-4">
                      <input
                        pInputText
                        appendTo="body"
                        jniAutoCompleteBlocker
                        type="text"
                        formControlName="nickName"
                        [(ngModel)]="task.nickName"
                        class="form-control" />
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span>{{ task.nickName }}</span>
                  </ng-template>
                </p-cellEditor>

                <!-- {{ task.nickName }} -->
              </td>
              <td
                class="name"
                formGroupName="subTask"
                *ngIf="taskType === 2"
                pEditableColumn>
                <!-- {{ task.esd | date: 'MM-dd-yyyy' }} -->
                <p-cellEditor>
                  <ng-template pTemplate="input" []>
                    <div class="form-group has-float-label mb-3 mt-4">
                      <p-datePicker
                        [selectOtherMonths]="true"
                        appendTo="body"
                        jniAutoCompleteBlocker
                        [inputStyle]="{ height: '30px' }"
                        [showButtonBar]="false"
                        formControlName="esd"
                        [minDate]="currentdate"
                        [defaultDate]="currentdate"
                        (onShow)="updateTaskDateField('subTask.esd', task.esd)"
                        (onSelect)="onSingleFieldEdit(task, 'esd', $event)">
                      </p-datePicker>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ task.esd | date: "MM-dd-yyyy" }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="name"
                [ngClass]="getLineIHDClass(task)"
                formGroupName="subTask"
                pEditableColumn>
                <!-- {{ task.ihd | date: 'MM-dd-yyyy' }} -->
                <p-cellEditor>
                  <ng-template pTemplate="input" []>
                    <div class="form-group has-float-label mb-3 mt-4">
                      <p-datePicker
                        [selectOtherMonths]="true"
                        appendTo="body"
                        jniAutoCompleteBlocker
                        [inputStyle]="{ height: '30px' }"
                        [style]="{ width: '100%' }"
                        [showButtonBar]="false"
                        formControlName="ihd"
                        [minDate]="currentdate"
                        [defaultDate]="currentdate"
                        (onShow)="updateTaskDateField('subTask.ihd', task.ihd)"
                        (onSelect)="onSingleFieldEdit(task, 'ihd', $event)">
                      </p-datePicker>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ task.ihd | date: "MM-dd-yyyy" }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="name text-truncate max-width-10" formGroupName="parentTask" pEditableColumn pTooltip="{{ task.title }}" tooltipPosition="top" placeholder="top">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <div class="form-group has-float-label mb-3 mt-4">
                      <input
                        pInputText
                        appendTo="body"
                        jniAutoCompleteBlocker
                        type="text"
                        formControlName="title"
                        [(ngModel)]="task.title"
                        class="form-control"
                        (change)="onInputChange()"
                        pInputText
                        (blur)="onTitleBlur(task, $event)" />
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <a
                 
                      
                      class="link"
                      (click)="
                        redirectToTaskSummary(task.taskId);
                        $event.stopPropagation()
                      "
                      >{{ task.title }}</a
                    >
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="name" formGroupName="subTask" pEditableColumn>
                <p-cellEditor *ngIf="!task.isArchived; else archiveTemplate">
                  <ng-template pTemplate="input" []>
                    <div class="form-group has-float-label mb-3 mt-4">
                      <p-datePicker
                        [selectOtherMonths]="true"
                        appendTo="body"
                        jniAutoCompleteBlocker
                        [inputStyle]="{ height: '30px' }"
                        [style]="{ width: '100%' }"
                        [showButtonBar]="false"
                        [minDate]="currentdate"
                        [defaultDate]="currentdate"
                        formControlName="dueDate"
                        (onShow)="
                          updateTaskDateField('subTask.dueDate', task.dueDate)
                        "
                        (onSelect)="onSingleFieldEdit(task, 'dueDate', $event)">
                        <ng-template pTemplate="footer">
                          <span class="link" (click)="archiveEvent(task, true)"
                            >Mark as archived</span
                          >
                        </ng-template>
                      </p-datePicker>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span>
                      {{ task.dueDate | date: "MM-dd-yyyy" }}
                    </span>
                  </ng-template>
                </p-cellEditor>
                <ng-template #archiveTemplate>
                  Archived
                  <div *ngIf="task.isArchived" class="unarchive-div">
                    <i
                      style="cursor: pointer"
                      (click)="archiveEvent(task, false)"
                      class="pi pi-arrow-circle-up"></i>
                  </div>
                </ng-template>
              </td>
              <td class="name" formGroupName="subTask" pEditableColumn>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      formControlName="priority"
                      notFoundText="No List Found"
                      appendTo="body"
                      [(ngModel)]="task.priorityType"
                      (onChange)="onSingleFieldEdit(task, 'priority', $event)"
                      [options]="priorityLevelFiltered"
                      [filter]="true"
                      [showClear]="true"
                      optionLabel="title"
                      optionValue="id">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ task.priorityTypeText }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="name" formGroupName="subTask" pEditableColumn>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      appendTo="body"
                      formControlName="assignedTo"
                      [(ngModel)]="task.assignedTo"
                      notFoundText="No List Found"
                      (onChange)="onSingleFieldEdit(task, 'assignedTo', $event)"
                      [filter]="true"
                      [showClear]="true"
                      [options]="renderUsers(ownerList)"
                      optionLabel="name"
                      optionValue="name">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ task.assignedTo }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="name">
                {{ task.createdBy }}
              </td>
              <td class="name">
                {{ task.owner }}
              </td>
              <td
                class="number text-center"
                (click)="
                  isDisableLink
                    ? $event.preventDefault()
                    : showTaskNoteSideBar(task.taskId, task.notes)
                ">
                <a class="link no-decoration "
                  ><i *ngIf="task.notes === ''" class="pi pi-plus"></i
                  ><i *ngIf="task.notes !== ''" class="pi pi-pen-to-square"></i
                ></a>
              </td>
              <td
                class=""
                formGroupName="subTask"
                *ngIf="taskType === 1"
                pEditableColumn>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      appendTo="body"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="task.status"
                      notFoundText="No List Found"
                      (onChange)="updateTaskStatus($event.value, task.taskId)"
                      [options]="statusList"
                      optionValue="value"
                      optionLabel="name"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ getTaskStatusTitleSales(task.status) }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class=""
                formGroupName="subTask"
                *ngIf="taskType === 2"
                pEditableColumn>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      appendTo="body"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="task.status"
                      notFoundText="No List Found"
                      (onChange)="onSingleFieldEdit(task, 'status', $event)"
                      [options]="statusList"
                      optionValue="value"
                      optionLabel="name"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ getTaskStatusTitleProduction(task.status) }}
                  </ng-template>
                </p-cellEditor>
              </td>
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20">No Task found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<jni-workflow-line-notes
  #tasknotessidebar
  [(display)]="displayTaskNoteSideBar"
  [notes]="taskNote"
  [taskId]="noteTaskId"
  (closeSidebar)="closeSideBarForNotes()"
  (saveNotesEvent)="saveTaskNotes($event)"
  [type]="type">
</jni-workflow-line-notes>

<p-dialog
  header="New Task"
  appendTo="body"
  [modal]="true"
  [position]="'center'"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showNewTaskModal"
  (onHide)="onHideNewTaskModal()"
  [style]="{
    width: '50%',
    'min-height': '250px',

    'border-radius': '10px',
    overflow: 'visible',
  }">
  <ng-template pTemplate="content">
    <div class="p-fluid p-dir-col p-p-3 mt-2" [formGroup]="taskForm">
      <div class="row mb-3" formGroupName="parentTask">
        <div class="col">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Title<span class="madatory-field">*</span></label
            >
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="title"
              [ngClass]="{
                'error-state': isFieldInvalid('parentTask', 'title'),
              }" />
          </div>
        </div>
      </div>
      <div class="row mb-3" formGroupName="subTask">
        <div class="col-6">
          <div class="form-group has-float-label">
            <label class="form-label">Nickname</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="nickName" />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group has-float-label">
            <label class="form-label">Assigned To</label>
            <p-select
              appendTo="body"
              formControlName="assignedTo"
              notFoundText="No List Found"
              [filter]="true"
              [showClear]="true"
              [options]="renderUsers(userList)"
              optionLabel="name"
              optionValue="name">
            </p-select>
          </div>
        </div>
      </div>
      <div class="row" formGroupName="subTask">
        <div class="col-6">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Due Date<span class="madatory-field">*</span></label
            >
            <p-datePicker
              jniAutoCompleteBlocker
              inputId="basic"
              class="date-input"
              formControlName="dueDate"
              [minDate]="currentdate"
              [defaultDate]="currentdate"
              [showOtherMonths]="true"
              [selectOtherMonths]="true"
              [ngClass]="{
                'error-state': isFieldInvalid('subTask', 'dueDate'),
              }"
              appendTo="body"></p-datePicker>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group has-float-label">
            <label class="form-label">Priority</label>
            <p-select
              formControlName="priority"
              notFoundText="No List Found"
              appendTo="body"
              [filter]="true"
              [showClear]="true"
              [options]="priorityLevelFiltered"
              optionLabel="title"
              optionValue="id">
            </p-select>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-2">
      <!-- <button
        class="btn btn-secondary"
        type="button"
        (click)="onHideNewTaskModal()">
        Cancel
      </button>
      <button class="btn btn-primary" type="button" (click)="addTask()">
        Add
      </button> -->

      <p-button
        label="Cancel"
        (click)="onHideNewTaskModal()"
        variant="outlined"
        severity="secondary" />

      <p-button label="Add" (click)="addTask()" />
    </div>
  </ng-template>
</p-dialog>
<jni-confirm-dialog
  [dialogMessage]="archiveMessage"
  dialogHeading="Are you sure?"
  *ngIf="archiveAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmArchive($event)">
</jni-confirm-dialog>
<p-dialog
  [style]="{ width: '80%', height: '95%', maxHeight: '100%' }"
  appendTo="body"
  [(visible)]="displayAddTaskModal"
  (onHide)="closeAddTask()">
  <jni-task-header
    *ngIf="displayAddTaskModal"
    [showTaskHeader]="showTaskModal"
    (closeAddTask)="closeAddTask()"
    [taskIdSelected]="taskIdSelected"
    [projectHeaderId]="workflowId"
    [buyer]="buyerName"
    (showContact)="showContactDialog($event)"
    [lockProject]="true">
  </jni-task-header>
</p-dialog>

<jni-task-header-edit
  #taskHeaderEdit
  *ngIf="displayTaskDetailModal"
  [displayModal]="displayTaskDetailModal"
  [showTaskHeader]="true"
  (closeAddTask)="closeTaskDetailModal()"
  [taskIdSelected]="taskIdSelected"
  [actionType]="taskIdSelected === 0 ? 'Add' : 'Edit'"
  [projectHeaderId]="workflowId"
  [buyer]="buyerName"
  (showContact)="showContactDialog($event)">
</jni-task-header-edit>
